import { AccountObject, IAccountObjectArgs } from '../account-object/account-object.model';

export interface ICategoryGroupArgs extends IAccountObjectArgs {
    title?: string;
    categories?: Array<string>;
}

const defaults = () => ({
    title: '',
    categories: []
});

export class CategoryGroup extends AccountObject {
    title: string;
    categories: Array<string>;

    constructor(args: ICategoryGroupArgs = {} as any) {
        super({...defaults(), ...args});
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category-group/category-group.model.ts